import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconNoWifiProps } from './IconNoWifi.types'
import * as Styled from './styles/IconNoWifi.style'

import { nonThemeableRules } from '../../ruleSet'

const IconNoWifi: FC<IconNoWifiProps> = ({
  size = nonThemeableRules.defaultSize as number as IconNoWifiProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconNoWifiProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M2.516 9.5c5.242-5.246 13.746-5.25 18.992-.008l.008.008' vectorEffect='non-scaling-stroke' />
          <path
            d='M5.23 12.313c3.743-3.747 9.82-3.75 13.567-.008l.008.008M4.45 19.57 19.585 4.43M8.074 15.484a5.573 5.573 0 0 1 7.887 0m-3.445 3.547a.501.501 0 1 1-.998-.002.501.501 0 0 1 .998.002Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M12.328 19.031a.31.31 0 0 1-.312.313.313.313 0 0 1-.313-.313c0-.172.14-.312.313-.312a.31.31 0 0 1 .312.312Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M12.14 19.031c0 .07-.054.125-.124.125a.126.126 0 0 1-.125-.125c0-.07.058-.125.125-.125.07 0 .125.055.125.125Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconNoWifi
